var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2455 2.25H13.3627C13.922 2.25346 14.4741 2.38353 14.9817 2.6315C15.4893 2.87947 15.9406 3.23957 16.3052 3.68742C16.6698 4.13528 16.9391 4.66057 17.095 5.22771C17.251 5.79485 17.2898 6.39072 17.209 6.97508C17.0452 9.30522 15.3735 10.8162 14.3224 11.7662C14.2114 11.8665 14.1073 11.9606 14.0126 12.0487C13.3689 12.648 11.7628 14.0308 10.7165 14.9262C10.1595 15.4027 9.34097 15.404 8.78297 14.9286C7.73212 14.0334 6.1195 12.6486 5.48902 12.0487C5.38499 11.9497 5.26868 11.8432 5.1437 11.7288C4.10396 10.7767 2.46388 9.27489 2.29267 6.97508C2.2102 6.39136 2.24757 5.79569 2.40218 5.22853C2.55679 4.66137 2.82503 4.13594 3.18879 3.68784C3.55254 3.23973 4.00328 2.87943 4.51045 2.63136C5.01762 2.38329 5.56946 2.25321 6.1284 2.25H6.22425C6.95353 2.27249 7.66369 2.50163 8.28037 2.9133C8.89705 3.32497 9.39761 3.90398 9.72962 4.58995C10.0643 3.90386 10.5669 3.32495 11.1853 2.91344C11.8036 2.50192 12.5149 2.27287 13.2455 2.25Z",
    fill: "#6A35DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart2);
export default __webpack_public_path__ + "static/media/heart2.343379559abc69ed1e287942a26ee3fa.svg";
export { ForwardRef as ReactComponent };